<template>
  <v-form @submit.prevent="submit">
    <v-text-field
      v-model="instrument.name"
      label="Nome"
      :error-messages="error.name || ''"
      required
    ></v-text-field>
    <v-checkbox
      v-model="instrument.is_rentable"
      label="Noleggiabile?"
      :error-messages="error.is_rentable || ''"
    ></v-checkbox>
    <v-checkbox
      v-model="instrument.is_cumbersome"
      label="Ingombrante?"
      :error-messages="error.is_cumbersome || ''"
    ></v-checkbox>
    <form-actions :loading="loading" @undo="reset" @submit="submit" />
  </v-form>
</template>

<script>
import { cloneDeep } from "@/lodash"

export default {
  props: {
    withData: {
      type: Object,
      default: () => ({}),
    },
    error: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      instrument: {},
    }
  },
  watch: {
    withData: {
      handler: "reset",
      deep: true,
    },
  },
  methods: {
    reset() {
      this.instrument = cloneDeep(this.withData)
    },
    submit() {
      this.$emit("submit", this.instrument)
    },
  },
}
</script>
